import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"

import ahoy from "ahoy.js"
ahoy.configure({
  visitsUrl: "/a/visits",
  eventsUrl: "/a/events",
  cookies: false,
  visitParams: {
    siteSlug: window.PerfilSiteSlug
  },
  visitDuration: 2 * 60, // 2 hours
  visitorDuration: 2 * 365 * 24 * 60 // 2 years
});

ahoy.trackView({ siteSlug: window.PerfilSiteSlug });
// ahoy.trackClicks();

const trackIndividualClick = function(e) {
  try {
    ahoy.track("_click", { href: e.target.href, text: e.target.innerHTML, linkId: e.target.dataset.linkId, siteSlug: window.PerfilSiteSlug });
  } catch(_) {
    console.log(_)
  }
};

const trackClicks = function() {
  const elements = document.querySelectorAll("[data-track]");
  [].forEach.call(elements, function(el) {
    el.addEventListener('click', trackIndividualClick);
  });
};

// document.addEventListener('DOMContentLoaded', trackClicks);
document.addEventListener('turbolinks:load', trackClicks);


Rails.start()
Turbolinks.start()
